import React from 'react';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { AutoAwesome } from '@mui/icons-material';
import { UPGRADE_PAGE } from '../../const/routes';
import { useHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  navbarItem: {
    position: 'relative',
    padding: theme.spacing(0, 1, 0, 0),
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    fontSize: 16,
  },
  navbarRibbon: {
    position: 'absolute',
    left: '86%',
    right: '0',
    border: '13px solid #e46a76',
    borderRight: '0',
    borderLeft: '10px solid transparent',
    height: '0',
    lineHeight: '0',
    width: '60px',
    color: 'white',
    zIndex: '1',
    fontSize: 12,
    WebkitFilter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))',
    filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: theme.spacing(1),
    '& span': {
      position: 'relative',
      padding: '0 4px 0 6px',
      textAlign: 'center',
    },
  },
  navbarText: {
    paddingLeft: theme.spacing(2),
    margin: 0,
  },
}));

const ProLicenseUpgrade = () => {
  const [flag, setShowFlag] = React.useState(true);
  const classes = useStyles();
  const history = useHistory();
  
  const redirectToUpgradePage = () => {
    setShowFlag(false);
    history.push(UPGRADE_PAGE);
  };
  
  return (
    <Box className={classes.navbarItem} onClick={redirectToUpgradePage}>
      {flag && <div className={classes.navbarRibbon}>
        <span>
          <FormattedMessage
            id="page.upgrade.new"
            defaultMessage="NEW"
          />
        </span>

      </div>}
      <AutoAwesome />
      <p className={classes.navbarText}>
        <FormattedMessage id="page.upgrade.pro" defaultMessage="Upgrade to PRO" />
      </p>
    </Box>
  );
};

export default (ProLicenseUpgrade);

